import { render, staticRenderFns } from "./AddBOIRequest.vue?vue&type=template&id=83b1339c&scoped=true&"
import script from "./AddBOIRequest.vue?vue&type=script&lang=ts&"
export * from "./AddBOIRequest.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83b1339c",
  null
  
)

export default component.exports